import { GET_INVESTORS_FILES } from './constants';

// TODO: ПЕРЕДЕЛАТЬ НА ЗАПРОС К API!!!!
export function loadInvestFiles() {
  return dispatch => dispatch({
    type: GET_INVESTORS_FILES,
    request: {
      method: 'GET',
      endpoint: 'investors/'
    }
  });
}



// WEBPACK FOOTER //
// ./src/redux/InvestorSection/actions.js